import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Login from './views/Login.vue';
import Vipps from './views/Vipps.vue';
import VippsLoggedin from './views/VippsLoggedin.vue';
//import Register from './views/Register.vue';
import vippsopenconfig from './config/vipps_open.config';


const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  });
}


Vue.use(Router);

// const client_id = '2a5a7cf0-ffdf-4be3-a644-bb85e626ac40';
// const scope = 'openid name phoneNumber address birthDate';
// const state = crypto.randomUUID();
// const redirect_uri = 'https://opprop.egset.net/auth/vipps/callback'

  export const router = new Router({
    mode: 'history',
    // duplicateNavigationPolicy: 'ignore',
    routes: [
      {
        path: '/',
        name: 'home',
        component: Home
      },
      {
        path: '/home',
        component: Home
      },
      {
        path: '/login',
        component: Login
      },
      {
        path: '/auth',
        component: Vipps
      },
      {
        path: '/vippsloggedin',
        component: VippsLoggedin
      },
      {
        path: '/auth/vipps/callback',
        component: Vipps
      },
      {
        path: "/auth/vipps/start_login",
        component: Vipps,
        beforeEnter(to, from, next) {
          console.log(to, from, next);
          // window.location.href = `https://api.vipps.no/access-management-1.0/access/oauth2/auth?client_id=${vippsopenconfig.client_id}&response_type=code&`
          //   + `scope=${vippsopenconfig.scope}&state=${vippsopenconfig.state}&redirect_uri=${vippsopenconfig.redirect_uri}`;
          window.location.href = `${vippsopenconfig.start_login_endpoint}?client_id=${vippsopenconfig.client_id}&response_type=code&`
            + `scope=${vippsopenconfig.scope}&state=${vippsopenconfig.state}&redirect_uri=${vippsopenconfig.redirect_uri}`;
        }, 
          // res.redirect('');
      },
      {
        path: '/register',
        name: 'register',
        // lazy-loaded
        component: () => import('./views/Register.vue')
      },
      {
        path: '/profile',
        name: 'profile',
        // lazy-loaded
        component: () => import('./views/Profile.vue')
      },
      {
        path: '/admin',
        name: 'admin',
        // lazy-loaded
        component: () => import('./views/BoardAdmin.vue')
      },
      {
        path: '/competition/:competition_id/admin',
        name: 'competition_admin',
        // lazy-loaded
        // component: () => import('./views/BoardCompetitions.vue')
        component: () => import('./views/BoardModerator.vue')
      },
      {
        path: '/competition/:competition_id/admin/add',
        name: 'competition_admin_add',
        // lazy-loaded
        // component: () => import('./views/BoardCompetitions.vue')
        component: () => import('./views/BoardCompetitionAdminAdd.vue')
      },
      {
        path: '/mod/competition/:competition_id/participants/',
        name: 'participants_moderator',
        // lazy-loaded
        component: () => import('./views/BoardParticipants.vue')
      },
      {
        path: '/mod/competition/:competition_id/participant/:participant_id',
        name: 'participant_moderator',
        // lazy-loaded
        component: () => import('./views/BoardModParticipant.vue')
      },
      {
        path: '/competition/:competition_id/teams',
        name: 'teams',
        // lazy-loaded
        component: () => import('./views/BoardTeams.vue')
      },
      {
        path: '/competition/:competition_id/team/:teamname',
        name: 'team',
        // lazy-loaded
        component: () => import('./views/BoardTeam.vue')
      },
      {
        path: '/competition/:competition_id/teamleader/:teamname',
        name: 'teamleader',
        // lazy-loaded
        component: () => import('./views/BoardTeamLeader.vue')
      },
      {
        path: '/competition/:competition_id/events',
        name: 'events',
        // lazy-loaded
        component: () => import('./views/BoardEvents.vue')
      },
      {
        path: '/competition/:competition_id/event/:event_id',
        name: 'event',
        // lazy-loaded
        component: () => import('./views/BoardEvent.vue')
      },
      {
        path: '/user',
        name: 'user',
        // lazy-loaded
        component: () => import('./views/BoardUser.vue')
      },
      {
        path: '/competition/:competition_id/participant/:participant_id',
        name: 'participant',
        // lazy-loaded
        component: () => import('./views/BoardParticipant.vue')
      },
      // Add route to AddChoice.vue
      {
        path: '/competition/addChoice',
        name: 'competitionaddchoice',
        // lazy-loaded
        component: () => import('./views/BoardCompetitionAddChoice.vue')
      },
      {
        path: '/competition/add',
        name: 'competitionadd',
        // lazy-loaded
        component: () => import('./views/BoardCompetitionAdd.vue')
      },
      {
        // path: '/callroom/upload',
        path: '/callroom/upload/:competition_id?/:competition_code?',
        name: 'callroomupload',
        // lazy-loaded
        component: () => import('./views/BoardCallroomUpload.vue')
      },
      {
        path: '/liveres/upload/:competition_id?/:competition_code?',
        name: 'liveresupload',
        // lazy-loaded
        component: () => import('./views/BoardLiveresUpload.vue')
      },
      {
        path: '/competitions',
        name: 'competitions',
        // lazy-loaded
        component: () => import('./views/BoardCompetitions.vue')
      },
      {
        path: '/competition/:competition_id/edit',
        name: 'competitionedit',
        // lazy-loaded
        component: () => import('./views/BoardCompetitionEdit.vue')
      },
      {
        path: '/competition/:competition_id',
        name: 'competition',
        // lazy-loaded
        component: () => import('./views/BoardCompetition.vue')
      },
      {
        path: '/competitionFull/:competition_id',
        name: 'competitionFull',
        // lazy-loaded
        component: () => import('./views/BoardCompetitionFull.vue')
      },
      {
        path: '/competition/:competition_id/activation/:payment_id?',
        name: 'competitionActivation',
        // lazy-loaded
        component: () => import('./views/BoardCompetitionActivation.vue')
      },
      {
        path: '/competition/:competition_id/mail',
        name: 'competitionMail',
        // lazy-loaded
        component: () => import('./views/BoardCompetitionMail.vue')
      },
      {
        path: '/competition/:competition_id/mail/verifyCompetitionTestEmailCode/:verification_hash',
        name: 'competitionMailVerification',
        // lazy-loaded
        component: () => import('./views/BoardCompetitionMailVerification.vue')
      },
    ]
  });

//
//router.beforeEach((to, from, next) => {
//  const publicPages = ['/login', '/register', '/home'];
//  const authRequired = !publicPages.includes(to.path);
//  const loggedIn = localStorage.getItem('user');
//
//  // trying to access a restricted page + not logged in
//  // redirect to login page
//  if (authRequired && !loggedIn) {
//    next('/login');
//  } else {
//    next();
//  }
//});

